import { defineMessages } from 'react-intl';

export const scope = 'app.containers.TileMapper';

export default defineMessages({
  noResults: {
    id: `${scope}.noResults`,
    defaultMessage: 'There are no reports from your sessions',
  },
});
